import { useQuery } from '@hooks/reactQuery';

import { getDynamicDates } from '@api/kpi';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { INameTitle } from '@awtg-ltd/react-map-component/dist/interfaces';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles, EVendorsValues, TVendorsValues } from '@enums/common';

import { KPI_DYNAMIC_DATES } from '@constants/queryKeys';

interface UseQueryDynamicDatesReturn {
	dynamicDatesOptions: TSelectOptionType<string>[];
	isLoadingDynamicDates: boolean;
}

export const useQueryDynamicDates = (vendor?: TVendorsValues): UseQueryDynamicDatesReturn => {
	const {
		data,
		isLoading: isLoadingDynamicDates,
	} = useQuery<INameTitle[], TSelectOptionType<string>[]>({
		queryKey: [KPI_DYNAMIC_DATES],
		queryFn: extractQueryParams(getDynamicDates),
		enabled: [vendor, vendor === EVendorsValues.oran],
		select: (dynamicDates) => optionsFormatted<TNameTitle>(dynamicDates),
		allowedRoles: [
			EUserRoles.networkOperatorKpiUpdater,
			EUserRoles.networkOperatorKpiViewer,
		],
		refetchOnWindowFocus: false,
	});

	return {
		dynamicDatesOptions: data || [],
		isLoadingDynamicDates: isLoadingDynamicDates,
	};
};
